import { useState, useEffect } from "react";
import { useChatStreamThoughtsSubscription } from "../graphql/subscriptions/chat-stream-thoughts.generated";

export const useChatStreamThoughts = (chatId: string) => {
  const [thoughts, setThoughts] = useState<string>("");
  const [isThinking, setIsThinking] = useState<boolean>(false);

  const { data, error } = useChatStreamThoughtsSubscription({
    variables: { chat_id: chatId },
    skip: !chatId,
    shouldResubscribe: true,
    onData: (args) => {
      const { data } = args;

      if (data.data?.chat_stream_thoughts?.length) {
        const thoughtsData = data.data.chat_stream_thoughts;

        // Sort by position to maintain order
        const sortedThoughts = thoughtsData
          .sort((a, b) => (a.position || 0) - (b.position || 0))
          .map((t) => t.thought_content)
          .filter(Boolean)
          .join("");
        setThoughts(sortedThoughts);
        // Keep thinking state true while we have an active chatId,
        // but set to false if we get a final thought marker or error
        if (sortedThoughts.length > 0) {
          setIsThinking(true);
        }
      }
    },
    onError: (error) => {
      console.error("Thoughts subscription error:", error);
      setIsThinking(false);
    },
  });

  // Reset thoughts when chatId changes
  useEffect(() => {
    setThoughts("");
    setIsThinking(!!chatId); // Start thinking when we have a chatId
  }, [chatId]);

  return {
    thoughts,
    isThinking,
    error,
  };
};
